import { setSliderHeight, isInternetExplorer } from './common';
// import Swiper from 'swiper/swiper'; // Fixme: Due to babel misconfiguration we use CDN in base.html
// import 'swiper/css/bundle';

const heroSliderSwiper = new Swiper('.homepage-hero-module .swiper', {
    direction: 'horizontal',
    loop: true,
    speed: 600,

    autoplay: {
        delay: 5000,
    },

    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },

    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

const textSliderSwiper = new Swiper('.text-slider-module .swiper', {
    direction: 'vertical',
    loop: true,
    speed: 600,

    autoplay: {
        delay: 5000,
    },

    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },

    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

function setSliderOnStart(section) {
    const tab = section.find('.tabs.slider-tabs');
    const $newSlide = tab.find(`.tab-pane:eq(${0})`);
    const tabContent = tab.find('.tab-content');

    const elementWidth = parseInt($newSlide.css('width'));
    const tabLength = tab.find('.tab-pane').length;

    const smallScreenLeftShift = ($(window).width() - elementWidth - 20) / 2;

    const shouldBeLargeShift = elementWidth === 500 || elementWidth === 400;
    const leftShift = shouldBeLargeShift ? 150 : smallScreenLeftShift;

    tabContent.animate({
        left: -(tabLength - 2) * (elementWidth + 20) + leftShift,
    });

    if (isInternetExplorer()) {
        section.find('.tab-content').css('min-width', tabContent.width()); // add additional style for ie
    }
}

$(function searchAndHandleSliders() {
    $.each($('.section-slider'), (_index, anchor) => {
        handleSlider($(anchor));
    });
});

function handleSlider(section) {
    setSliderOnStart(section);

    section
        .find('.tab-content')
        .find('.tab-pane:eq(1)')
        .addClass('active');

    const tabs = section.find('.tabs');
    tabs.find('.nav-tabs a[role*="tab"]:eq(1)').addClass('active');

    setSliderHeight();

    section.find('.nav-tabs').append('<img src="/static/img/sliderArrow.svg" class="next-arrow" alt="next-arrow">');
    section.find('.nav-tabs').prepend('<img src="/static/img/sliderArrow.svg" class="prev-arrow" alt="prev-arrow">');
    const nextArrow = section.find('.nav-tabs').find('.next-arrow');
    const prevArrow = section.find('.nav-tabs').find('.prev-arrow');

    const tab = section.find('.tabs.slider-tabs');
    const tabLength = tab.find('.tab-pane').length;

    let mainIndex = 1;
    let prevIndex = null;
    nextArrow.click(function() {
        if (mainIndex < tabLength - 1) {
            prevIndex = mainIndex;
            mainIndex++;
            moveSlider(mainIndex, prevIndex, section);
        }
    });

    prevArrow.click(function() {
        if (mainIndex > 0) {
            prevIndex = mainIndex;
            mainIndex--;
            moveSlider(mainIndex, prevIndex, section);
        }
    });

    section.find('.nav-tabs a[role*="tab"]').click(function(e) {
        const index = $(this)
            .closest('li')
            .index();

        prevIndex = mainIndex;
        mainIndex = index - 1;

        moveSlider(mainIndex, prevIndex, section);

        e.preventDefault();
    });
}

function moveSlider(index, prevIndex, section) {
    const tab = section.find('.tabs.slider-tabs');

    $.each(tab.find('a[role*="tab"]'), (tabIndex, anchor) => {
        $(anchor).removeClass('active');
        if (index === tabIndex) {
            $(anchor).addClass('active');
        }
    });

    if (index === prevIndex) {
        return;
    }
    const $newSlide = tab.find(`.tab-pane:eq(${index})`);
    const $prevSlide = tab.find(`.tab-pane:eq(${prevIndex})`);

    const tabContent = tab.find('.tab-content');

    const elementWidth = parseInt($newSlide.css('width'));
    const tabLength = tab.find('.tab-pane').length;

    const smallScreenLeftShift = ($(window).width() - elementWidth - 20) / 2;
    const shouldBeLargeShift = elementWidth === 500 || elementWidth === 400;

    const leftShift = shouldBeLargeShift ? 150 : smallScreenLeftShift;

    tabContent.animate(
        {
            left: -(tabLength - index - 1) * (elementWidth + 20) + leftShift,
        },
        300,
        () => $prevSlide.removeClass('active'),
    );

    $newSlide.addClass('active');
}



// WEBPACK FOOTER //
// ./js/sliders.js